import React, { lazy, Suspense } from 'react';
import DashboardErrorBoundary from './DashboardErrorBoundary.js';
import PerformanceDashboardSkeleton from './PerformanceDashboardSkeleton.js';

/*
 * このファイルは recharts を読み込まない。App.js が静的に読み込む。
 * グラフの部品（recharts）を含む画面の本体は、/dashboard を開いたときに読み込む。静的に読み込むと、
 * ほかの画面を含む最初の読み込みが gzip で約 120 kB 増えるため（SCR-P-001 §6.1。Issue #1958）
 */

const loadPage = () => import('./index.js');

/**
 * /dashboard の中身を作る。読み込む間はスケルトン、読み込めなかったら §6.3 の文を出す
 *
 * @param {() => Promise<{default: React.ComponentType}>} [load] - 画面の本体の読み込み（テストで差し替える）
 * @returns {React.ComponentType}
 */
export function createPerformanceDashboardRoute(load = loadPage) {
    const Page = lazy(load);
    return function PerformanceDashboardRoute() {
        return (
            <DashboardErrorBoundary>
                <Suspense fallback={<PerformanceDashboardSkeleton />}>
                    <Page />
                </Suspense>
            </DashboardErrorBoundary>
        );
    };
}

export default createPerformanceDashboardRoute();
